import React, { useState, useEffect } from "react";
import Select from "react-select";
import { getCompanyActivities } from "./Axios";

const CompanyActivitySelect = props => {
  const [company_activities, setCompanyActivities] = useState([]);

  const handleChange = selectedOption => {
    props.handleChange(selectedOption, "company_activity");
  };

  useEffect(() => {
    getCompanyActivities((response) => {
      if (response && response.data) {
        const newCompanyActivities = response.data.map((company_activity) => ({
          value: company_activity.id,
          label: company_activity.name,
          uniqueIdentifier: company_activity.unique_identifier,
        }));
        setCompanyActivities(newCompanyActivities);
      }
    });
  }, []);

  return (
    <Select
      inputId="trabajando-company-activity-search"
      onChange={handleChange}
      options={company_activities}
      placeholder="Buscar y seleccionar una actividad de la empresa"
      value={
        company_activities.find(
          (option) => option.value === props.value?.value
        ) || null
      }
      getOptionLabel={(e) => `${e.label}`}
      filterOption={(option, input) => {
        const searchTerm = input.toLowerCase();
        const { label } = option.data;
        return (
          label.toLowerCase().includes(searchTerm)
        );
      }}
      isSearchable={true}
    />
  );
};

export default CompanyActivitySelect;

